import React from 'react';
export function TestsiegerPromo() {
  return <section className="py-12 bg-white" data-id="element-317">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-318">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-12" data-id="element-319">
          Wähle dein Vorteilspaket und spare:
        </h2>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-320">
          {/* Probierpackung */}
          <div className="bg-white border-2 border-gray-300 rounded-lg p-6 flex flex-col" data-id="element-321">
            <h3 className="text-2xl font-bold text-gray-600 text-center mb-2" data-id="element-322">
              1x eve® Nourishing Vanilla Protein (vegan)
            </h3>
            <div className="flex items-center justify-center mb-4" data-id="element-323">
              <span className="text-lg font-semibold mr-2" data-id="element-324">(4,8)</span>
              <div className="flex" data-id="element-325">
                {[1, 2, 3, 4].map(star => <svg key={star} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-326">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-327" />
                  </svg>)}
                <svg className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" style={{
                clipPath: 'inset(0 50% 0 0)'
              }} data-id="element-328">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-329" />
                </svg>
              </div>
            </div>
            <div className="flex-grow flex items-center justify-center mb-6" data-id="element-330">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fPBwv4vNwxLaJv5cP4p2vk/EVE-Vanilla-Protein-single-offer.jpg" alt="eve Nourishing Vanilla Protein Probierpackung" className="w-[260px] h-auto" data-id="element-331" />
            </div>
            <h4 className="text-2xl font-bold text-center text-gray-900 mb-1" data-id="element-332">
              Probierpackung
            </h4>
            <p className="text-center text-gray-600 mb-4" data-id="element-333">450g Inhalt</p>
            <p className="text-3xl font-bold text-center text-gray-900 mb-6" data-id="element-334">
              Nur 41,95€
            </p>
            <a href="https://weesesumecontasy.com/click/2" className="block w-full" data-id="element-335">
              <button className="w-full bg-gray-600 hover:bg-gray-700 text-white font-bold py-4 px-6 rounded-lg transition duration-300 text-lg" data-id="element-336">
                JETZT BESTELLEN
              </button>
            </a>
            <p className="text-center text-sm text-gray-600 mt-4" data-id="element-337">
              Geld-Zurück-Garantie
            </p>
          </div>
          {/* 6 Wochen Starter-Set - BESTER WERT */}
          <div className="bg-gradient-to-b from-orange-500 to-orange-600 border-4 border-orange-600 rounded-lg p-6 flex flex-col relative" data-id="element-338">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-orange-500 text-white font-bold px-6 py-2 rounded-full text-sm" data-id="element-339">
              BESTER WERT
            </div>
            <h3 className="text-2xl font-bold text-white text-center mb-2 mt-2" data-id="element-340">
              3x eve® Nourishing Vanilla Protein (vegan)
            </h3>
            <div className="flex items-center justify-center mb-4" data-id="element-341">
              <span className="text-lg font-semibold text-white mr-2" data-id="element-342">
                (4,8)
              </span>
              <div className="flex" data-id="element-343">
                {[1, 2, 3, 4].map(star => <svg key={star} className="w-5 h-5 text-yellow-300" fill="currentColor" viewBox="0 0 20 20" data-id="element-344">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-345" />
                  </svg>)}
                <svg className="w-5 h-5 text-yellow-300" fill="currentColor" viewBox="0 0 20 20" style={{
                clipPath: 'inset(0 50% 0 0)'
              }} data-id="element-346">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-347" />
                </svg>
              </div>
            </div>
            <div className="flex-grow flex items-center justify-center mb-4 relative" data-id="element-348">
              <div className="relative" data-id="element-349">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eAeHEgnUEbnWxnowKfz4hy/EVE-Vanilla-offer_45.png" alt="eve 6 Wochen Starter-Set mit Gratis Creatin" className="w-[346px] h-auto" data-id="element-350" />
              </div>
            </div>
            <div className="bg-orange-400 rounded-lg p-2 mb-4 text-center" data-id="element-351">
              <p className="text-white font-bold text-sm" data-id="element-352">
                +++ Gratis Rezeptebuch
              </p>
            </div>
            <h4 className="text-2xl font-bold text-center text-white mb-1" data-id="element-353">
              6 Wochen Starter-Set
            </h4>
            <p className="text-center text-white mb-4" data-id="element-354">1.350g Inhalt</p>
            <p className="text-3xl font-bold text-center text-white mb-1" data-id="element-355">
              Nur 23,07€ <span className="text-xl" data-id="element-356">pro Stück</span>
            </p>
            <p className="text-center text-white mb-2" data-id="element-357">
              <span className="font-bold" data-id="element-358">Gesamt: Nur 69,22</span>{' '}
              <span className="line-through" data-id="element-359">125,95€</span>
            </p>
            <p className="text-center text-white text-sm mb-6" data-id="element-360">
              (56,63 € geschenkt)
            </p>
            <a href="https://weesesumecontasy.com/click/2" className="block w-full" data-id="element-361">
              <button className="w-full bg-white hover:bg-gray-100 text-orange-600 font-bold py-4 px-6 rounded-lg transition duration-300 text-lg shadow-lg" data-id="element-362">
                JETZT BESTELLEN
              </button>
            </a>
            <p className="text-center text-sm text-white mt-4" data-id="element-363">
              Gratis Versand & Geld-Zurück-Garantie
            </p>
          </div>
          {/* 4 Wochen Paket */}
          <div className="bg-white border-2 border-gray-300 rounded-lg p-6 flex flex-col" data-id="element-364">
            <h3 className="text-2xl font-bold text-gray-600 text-center mb-2" data-id="element-365">
              2x eve® Nourishing Vanilla Protein (vegan)
            </h3>
            <div className="flex items-center justify-center mb-4" data-id="element-366">
              <span className="text-lg font-semibold mr-2" data-id="element-367">(4,8)</span>
              <div className="flex" data-id="element-368">
                {[1, 2, 3, 4].map(star => <svg key={star} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-369">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-370" />
                  </svg>)}
                <svg className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" style={{
                clipPath: 'inset(0 50% 0 0)'
              }} data-id="element-371">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-372" />
                </svg>
              </div>
            </div>
            <div className="flex-grow flex items-center justify-center mb-6 relative" data-id="element-373">
              <div className="relative" data-id="element-374">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/q5Kp825XtdG1xp6C7b6cN1/EVE-Vanilla-Protein-double-offer-15.jpg" alt="eve 4 Wochen Paket" className="w-[260px] h-auto" data-id="element-375" />
              </div>
            </div>
            <h4 className="text-2xl font-bold text-center text-gray-900 mb-1" data-id="element-376">
              4 Wochen Paket
            </h4>
            <p className="text-center text-gray-600 mb-4" data-id="element-377">900g Inhalt</p>
            <p className="text-3xl font-bold text-center text-emerald-600 mb-1" data-id="element-378">
              Nur 35,66€{' '}
              <span className="text-xl text-gray-600" data-id="element-379">pro Stück</span>
            </p>
            <p className="text-center text-gray-900 mb-2" data-id="element-380">
              <span className="font-bold" data-id="element-381">Gesamt: Nur 71,32</span>{' '}
              <span className="line-through text-gray-500" data-id="element-382">83,90€</span>
            </p>
            <p className="text-center text-gray-600 text-sm mb-6" data-id="element-383">
              (12,58 € geschenkt)
            </p>
            <a href="https://weesesumecontasy.com/click/2" className="block w-full" data-id="element-384">
              <button className="w-full bg-gray-800 hover:bg-gray-900 text-white font-bold py-4 px-6 rounded-lg transition duration-300 text-lg" data-id="element-385">
                JETZT BESTELLEN
              </button>
            </a>
            <p className="text-center text-sm text-gray-600 mt-4" data-id="element-386">
              Gratis Versand & Geld-Zurück-Garantie
            </p>
          </div>
        </div>
      </div>
    </section>;
}